import { isFunction } from "../IsFunction";
/**
 * Map of all the loaded paths.
 * @private
 */
var scripts = {};
/* istanbul ignore next */
export function dynamicScriptLoad(path, res, rej) {
    var paths = Array.isArray(path) ? path : [path];
    var error = isFunction(rej) ? rej : function () { };
    var success = isFunction(res) ? res : function () { };
    var result = undefined;
    /*
    The reason this function is ignored from tests coverage is because it is using browser APIs to
    download and execute scripts that cannot be emulated in NodeJS runtime.

    In order to do tests for it we need to emulate:
    - document
    - - - getElementsByTagName()
    - - - createElement()
    - head element
    - - - insertBefore()
    - script element
    - - - fetch script from URL and parse it as source of the script element
    - - - onload
    - - - onerror
    - - - onreadystatechange
    - - - readyState
    */
    /* istanbul ignore next */
    var promise = Promise.all(paths.map(function (x) { return new Promise(function (resolve, reject) {
        if (!scripts[x] && x !== "") {
            var head = document.getElementsByTagName("head")[0];
            var el_1 = document.createElement("script"), loaded_1 = 0;
            el_1.onload = el_1["onreadystatechange"] = function (e) {
                if ((el_1["readyState"] &&
                    !(/^c|loade/.test(el_1["readyState"]))) ||
                    loaded_1) {
                    return;
                }
                loaded_1 = 1;
                scripts[x] = true;
                // tslint:disable-next-line
                el_1.onload = el_1["onreadystatechange"] = null;
                resolve(x);
            };
            el_1.onerror = function (e) {
                var src = e && typeof e !== "string" && e.target && e.target["src"];
                if (src) {
                    console.warn("Failed to download file at: " + src);
                }
                else {
                    console.warn("Failed to download file. Err: " + e);
                }
                reject(e);
            };
            el_1.async = true;
            el_1.src = x;
            head.insertBefore(el_1, head.lastChild);
        }
        else {
            resolve(x);
        }
    }); }));
    /* istanbul ignore next */
    if (typeof res === "undefined" && typeof rej === "undefined") {
        result = promise;
        /* istanbul ignore next */
    }
    else {
        promise
            .then(/* istanbul ignore next */ function (/* istanbul ignore next */ x) {
            success(x);
            return x;
        })
            .catch(/* istanbul ignore next */ function (/* istanbul ignore next */ x) {
            error(x, paths);
            return x;
        });
    }
    return result;
}
//# sourceMappingURL=DynamicScriptLoad.js.map